export default __webpack_public_path__ + "static/media/Liquidity-White.79d3719a.png";